export const AlreadyLoggedInComponent = {
    template: `
        <div class="landing-already-logged-in-container content-padding">
            <div class="glyph-error-container">
                <span class="glyph glyph-error"></span>
            </div>
            <oo-alert severity="warning">
                <oo-alert-message>You have already logged in! Please continue.</oo-alert-message>
            </oo-alert>
            <div>
                <button
                    id="landing-already-logged-in-continue-button"
                    class="button button-primary button-full"
                    ui-sref="start"
                >
                    Continue
                </button>
            </div>
            <div class="landing-already-logged-in-footer">
                <oo-branding></oo-branding>
            </div>
        </div>
    `,
    controller: class {
    }
};
